import { useState } from "react";
import {
  required,
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  BooleanInput,
  RadioButtonGroupInput,
  FormDataConsumer,
  useDataProvider,
  useNotify,
  useRedirect,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import * as S from "./index.styles";
import { fieldsForCleaning, MESSAGES } from "./utils";

const validateRequired = required();

const OrderCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const [kit, setKit] = useState("");
  const [kitName, setKitName] = useState("Kit");
  const [labId, setLabId] = useState("");

  const handleCycleChange = async (id) => {
    setKitName("...");

    const { data } = await dataProvider.getList("cycles", {
      filter: { id: id },
      sort: { field: "id", order: "DESC" },
      pagination: { page: 1, perPage: 1 },
    });

    const kits = data[0].samplesList?.map((sample) => sample?.sample).join(",");
    setKit(data[0].kitId);
    setKitName(
      data[0].kit.externalId ? `${data[0].kit.externalId} - ${kits}` : kits
    );
  };

  const handleSuccess = () => {
    notify(MESSAGES.ORDER_IN_PROGRESS, { type: "info" });
    redirect("/orders");
  };

  const LabSelect = () => {
    const { setValue } = useFormContext();

    const handleLabChange = (e) => {
      setLabId(e.target.value);

      if (!labId) return;

      notify(MESSAGES.LAB_CHANGED, { type: 'info' });

      fieldsForCleaning.forEach((field) => {
        setValue(field, "");
      });
    };

    return (
      <ReferenceInput
        sort={{ field: "name", order: "ASC" }}
        perPage={999}
        source="labId"
        resource="lab"
        reference="labs"
      >
        <SelectInput
          label="Laboratório"
          className="filds-container"
          optionText="name"
          optionValue="id"
          validate={validateRequired}
          onChange={handleLabChange}
        />
      </ReferenceInput>
    );
  };

  return (
    <S.View>
      <Create title="Novo Pedido" mutationOptions={{ onSuccess: () => handleSuccess() }} {...props}>
        <SimpleForm>
          <FormDataConsumer>
            {({ formData }) => {
              return (
                <>
                  <LabSelect />

                  {formData.labId && (
                    <ReferenceInput
                      perPage={999}
                      source="panelId"
                      reference="panels"
                      filter={{ panel: { labId: formData.labId } }}
                      sort={{ field: "id", order: "DESC" }}
                    >
                      <SelectInput
                        className="filds-container"
                        label="Painel"
                        optionValue="id"
                        optionText="name"
                        validate={validateRequired}
                      />
                    </ReferenceInput>
                  )}

                  {formData.labId && (
                    <ReferenceInput
                      perPage={999}
                      source="projectId"
                      reference="projects"
                      filter={{ project: { labId: formData.labId } }}
                      sort={{ field: "id", order: "DESC" }}
                    >
                      <SelectInput
                        className="filds-container"
                        label="Projeto"
                        optionText="name"
                        optionValue="id"
                        validate={validateRequired}
                      />
                    </ReferenceInput>
                  )}

                  {formData.projectId && (
                    <ReferenceInput
                      perPage={999}
                      source="campaignId"
                      reference="campaigns"
                      filter={{ campaign: { projectId: formData.projectId } }}
                      sort={{ field: "id", order: "DESC" }}
                    >
                      <SelectInput
                        className="filds-container"
                        label="Campanha"
                        optionText="name"
                        optionValue="id"
                        validate={validateRequired}
                      />
                    </ReferenceInput>
                  )}

                  <RadioButtonGroupInput
                    choices={[
                      { id: "1", name: "Novo ciclo" },
                      { id: "2", name: "Ciclo existente" },
                    ]}
                    className="filds-container"
                    defaultValue="1"
                    label="Ciclo"
                    validate={validateRequired}
                    onChange={() => (formData.kitId = "")}
                    source="select_cycle"
                  />

                  {formData.select_cycle === "2" && (
                    <ReferenceInput
                      perPage={999}
                      source="cycleId"
                      reference="cycles"
                      filter={{
                        lab: { id: formData.labId },
                        lightJoin: true
                      }}
                      sort={{ field: "id", order: "DESC" }}
                    >
                      <SelectInput
                        className="filds-container"
                        label="Ciclos"
                        onChange={(event) =>
                          handleCycleChange(event.target.value)
                        }
                        optionText="id"
                        optionValue="id"
                        validate={validateRequired}
                      />
                    </ReferenceInput>
                  )}

                  {kit && formData.select_cycle === "2" && (
                    <div className="container-input-kit">
                      <p>Kit *</p>
                      <span className="input-kit">{kitName}</span>
                    </div>
                  )}

                  {formData.labId && formData.select_cycle !== "2" && (
                    <ReferenceInput
                      perPage={999}
                      source={"kitId"}
                      reference="kits"
                      filter={{ lab: { id: formData.labId } }}
                      sort={{ field: "externalId", order: "DESC" }}
                    >
                      <SelectInput
                        className="filds-container"
                        label="Kit"
                        optionValue="id"
                        optionText="kitContentString"
                        validate={validateRequired}
                      />
                    </ReferenceInput>
                  )}

                  <RadioButtonGroupInput
                    className="filds-container"
                    defaultValue="0"
                    label="Tipo de Envio"
                    validate={validateRequired}
                    source="type"
                    choices={[
                      { id: "0", name: "Caixa" },
                      { id: "1", name: "Caixa Sem Modulação" },
                      { id: "2", name: "Carta" },
                    ]}
                  />

                  <BooleanInput
                    className="filds-container"
                    label="Confirmação Obrigatória"
                    source="needsConfirmation"
                  />
                  <BooleanInput
                    className="filds-container"
                    label="Usar endereço do Painel"
                    source="forceProvidedAddress"
                  />

                </>
              );
            }}
          </FormDataConsumer>
        </SimpleForm>
      </Create>
    </S.View>
  );
};

export default OrderCreate;
